"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var cachedServicePromises = [];
// The cache timeout in miliseconds
//
var cacheTimeout = 500;
var serviceCache;
(function (serviceCache) {
    function setCacheTimeout(newCacheTimeout) {
        cacheTimeout = newCacheTimeout;
    }
    function flush(serviceName) {
        if (serviceName) {
            _.remove(cachedServicePromises, { serviceName: serviceName });
        }
        else {
            cachedServicePromises = [];
        }
    }
    serviceCache.flush = flush;
    function prune() {
        // Calculate the time limit
        //
        var limit_ts = +(new Date()) - cacheTimeout;
        _.remove(cachedServicePromises, function (cacheEntry) {
            // Remove all entries older then time limit
            //
            return cacheEntry.ts < limit_ts;
        });
    }
    function get(serviceName, requestData, method, path) {
        // First prune the cache
        //
        prune();
        var callData = JSON.stringify(requestData);
        var cacheEntry = _.find(cachedServicePromises, {
            serviceName: serviceName,
            path: path,
            method: method,
            callData: callData
        });
        return _.get(cacheEntry, "promise");
    }
    serviceCache.get = get;
    function add(serviceName, requestData, method, path, promise) {
        // First prune the cache
        //
        prune();
        // Add the new promise
        //
        var cacheEntry = {
            ts: +(new Date()),
            serviceName: serviceName,
            promise: promise,
            path: path,
            method: method,
            callData: JSON.stringify(requestData)
        };
        cachedServicePromises.push(cacheEntry);
    }
    serviceCache.add = add;
})(serviceCache = exports.serviceCache || (exports.serviceCache = {}));
